/**
 * Styles for the DateCalendar component
 */
const DateTimeStyles = () => ({
  display: 'flex',
  flexDirection: 'column',
  '& .MuiInputBase-root': {
    textAlignLast: 'left',
  },
  '& .MuiDayCalendar-header': {
    display: 'flex',
    justifyContent: 'space-evenly',
    padding: 0,
  },
  '& .MuiDayCalendar-weekDayLabel': {
    fontSize: '1rem',
    margin: 0,
  },
  '.MuiDayCalendar-weekContainer': {
    display: 'flex',
    justifyContent: 'space-evenly',
    padding: 0,
    '& .MuiPickersDay-today': {
      border: 'none',
    },
    '& .MuiPickersDay-root': {
      fontSize: '1rem',
      margin: 0,
      borderRadius: '50%',
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: 'rgba(0, 124, 146, 0.04)',
      },
    },
    '& .Mui-selected': {
      backgroundColor: '#007C92 !important',
      '&:hover': {
        backgroundColor: '#007C92',
      },
    },
  },
  '& .MuiMultiSectionDigitalClock-root': {
    padding: '1.25rem 0.5rem 0',
    width: '6.25rem',
    gap: '0.75rem',
    borderLeft: '1px solid #E0E0E0',
  },
  '& .MuiMultiSectionDigitalClockSection-root': {
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '&:not(:first-of-type)': {
      borderLeft: 'none',
    },
    '& .MuiMenuItem-root': {
      width: '2.25rem',
      height: '2.25rem',
      fontSize: '1rem',
      padding: 0,
      margin: 0,
      borderRadius: '50%',
      '&:hover': {
        backgroundColor: 'rgba(0, 124, 146, 0.04)',
      },
      '&.Mui-selected': {
        backgroundColor: '#007C92',
        color: '#fff',
        '&:hover': {
          backgroundColor: '#007C92',
        },
      },
    },
  },
});

export default DateTimeStyles;
